module.exports = __webpack_public_path__ + "img/hand.fd625bfc.svg";